import type { WorldFeature } from '../types';
import { lifeFeature } from './lifeFeature';
import { birdsFeature } from './birdsFeature';
import { activityFeature } from './activityFeature';
import { feedingFeature } from './feedingFeature';
import { cargoFeature } from './cargoFeature';
import { draftTrafficFeature } from './draftTrafficFeature';
import { pigeonFeature } from './pigeonFeature';
import { crowdFeature } from './crowd/crowdFeature';
import { civicFeature } from './civicFeature';
import { streetPlayFeature } from './streetPlayFeature';
import { hearthSmokeFeature } from './hearthSmokeFeature';

export const LIFE_FEATURES: readonly WorldFeature[] = [
  lifeFeature,
  crowdFeature,
  hearthSmokeFeature,
  birdsFeature,
  activityFeature,
  streetPlayFeature,
  pigeonFeature,
  feedingFeature,
  cargoFeature,
  draftTrafficFeature,
  civicFeature,
];
export { lifeFeature } from './lifeFeature';
export { CITIZEN_ROLES, type CitizenRole, type LifeRoute } from './types';
